<div class="header">
    <strong>ID ATENDIMENTO</strong>
    <strong>DATA</strong>
    <strong>SUB-CÉLULA</strong>
    <strong>STATUS</strong>
  </div>
